import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import { createActionResponseFactory } from '@core/ngrx-legacy';
import type { Position } from '@core/positions-and-skills-types';
import { PositionsActions, PositionsSelectors } from '@recruitee/positions-and-skills-data';

@Injectable({
  providedIn: 'root',
})
export class PositionsDataService {
  private readonly store = inject(Store);
  private readonly positionsActionResponse = createActionResponseFactory(PositionsActions);

  public positions$ = this.store.select(PositionsSelectors.entities()).pipe(
    filterBoolean,
    map(positions => [...positions].sort((a, b) => a.name.localeCompare(b.name))),
  );

  public positionsLoaded$ = this.store.select(PositionsSelectors.isLoaded());

  public selectPositionById$(id: number) {
    return this.store.select(PositionsSelectors.byId(id));
  }

  public positionsMap() {
    return this.store.selectSignal(PositionsSelectors.entityMap);
  }

  public fetchPositions() {
    this.store.dispatch(PositionsActions.fetchCollection());
  }

  public fetchPosition(id: number) {
    this.store.dispatch(PositionsActions.fetchOne({ payload: { id } }));
  }

  public fetchSuggestedPosition(params: {
    offerId?: number;
    offerTemplateId?: number;
  }): Observable<Position | null> {
    return this.positionsActionResponse(PositionsActions.fetchSuggestion, { payload: params }).pipe(
      map(result => (result.isSuccess ? result.action.payload.data : null)),
    );
  }
}
